import { Controller } from "@hotwired/stimulus";

/**
 * Stimulus controller for recovery codes copy/download functionality.
 *
 * Usage in HTML:
 *   <div data-controller="recovery-codes">
 *     <code data-recovery-codes-target="code">ABC12-DEF34</code>
 *     <button data-action="click->recovery-codes#copy">Copy</button>
 *     <button data-action="click->recovery-codes#download">Download</button>
 *   </div>
 */
export class RecoveryCodesController extends Controller {
  static targets = ["code"];

  getCodes() {
    return this.codeTargets.map((el) => el.textContent).join("\n");
  }

  copy(event) {
    event.preventDefault();
    const codes = this.getCodes();

    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard
        .writeText(codes)
        .then(() => {
          alert("Recovery codes copied to clipboard!");
        })
        .catch(() => {
          this.fallbackCopy(codes);
        });
    } else {
      this.fallbackCopy(codes);
    }
  }

  fallbackCopy(text) {
    const textarea = document.createElement("textarea");
    textarea.value = text;
    textarea.style.position = "fixed";
    textarea.style.opacity = "0";
    document.body.appendChild(textarea);
    textarea.select();
    try {
      document.execCommand("copy");
      alert("Recovery codes copied to clipboard!");
    } catch (err) {
      prompt("Copy these codes manually:", text);
    }
    document.body.removeChild(textarea);
  }

  download(event) {
    event.preventDefault();
    const codes = this.getCodes();
    const header =
      "getregistered Recovery Codes\n" +
      "Generated: " +
      new Date().toISOString() +
      "\n\n" +
      "Keep these codes in a safe place.\n" +
      "Each code can only be used once.\n\n";
    const blob = new Blob([header + codes], { type: "text/plain" });
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = "getregistered-recovery-codes.txt";
    a.click();
    URL.revokeObjectURL(url);
  }
}
